import { CustomTabPanel } from "@/erp";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import SolicitudTransferenciaInventarioTable from "../solicitud-transferencia-inventario/componente/SolicitudTransferenciaInventarioTable";
import { a11yProps } from "@/shared";
import { EstadoSolicitudTransferencia } from "@/shared/interfaces";


export default function RevisionSolicitudTransferenciaInventarioPage() {

  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene
      title="Revisión de Solicitudes de Transferencia"
      visibleReport={false}
    >
      <Tabs
        value={valueTab}
        onChange={(_event: React.SyntheticEvent, newValue: number) => {
          setValueTab(newValue);
        }}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs preventa"
      >
        <Tab label={'Solicitud'} {...a11yProps(0)} />
      </Tabs>

      <CustomTabPanel index={valueTab} value={0}>
        <SolicitudTransferenciaInventarioTable estado={EstadoSolicitudTransferencia.EN_ESPERA}
          action={true}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );

}